// extracted by mini-css-extract-plugin
export default {"content":"NotificationsContainer__content__cMwn0","mobile":"NotificationsContainer__mobile__B3TrV"};